// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1897":"d904c7bf","9510":"d59bccd2"}[chunkId] || chunkId) + "." + {"1897":"8db05f19984ac560","3764":"eca76fbea70478d3","3814":"01a3ab75d96e8e85","9291":"46a903adbb89155d","9510":"8520d0f465ba455b"}[chunkId] + ".js";
};